namespace HA.Core.HTML.Editor {
    export class SelectorItem extends FlexContainer {

        public getValue() {
            return this.get("v") || this.get("item");
        }

        public equals(val: string): boolean {
            return this.getValue() === val;
        }

        /**
         *
         * @returns {boolean}
         */
        public isChecked(): boolean {
            return !!this.get("s");
        }

        public toggleSelection(): void {
            if (this.has("pfunc")) {
                this.get("pfunc")(this.getValue());
            }
            if (this.isChecked()) {
                this.unchecked();
            } else {
                this.checked();
            }
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("si");
            this.addToData("id", this.getValue());

            const me = this;
            let div: Tag = null;

            if (this.has("v")) {
                div = new Div(this.get("v"));
            } else if (this.has("item")) {
                div = this.get("item");
            }

            this.onClick(() => {
                me.toggleSelection();
            });

            this.addToData("icon", new Div());
            this.addToData("txt", div);
            if (this.isChecked()) {
                this.checked();
            }

            this.appendChildRight(this.getIcon());
            this.appendChild(div);
        }

        /**
         *
         * @returns {Div}
         */
        protected getIcon() {
            return this.get("icon");
        }

        /**
         *
         * @returns {Div}
         */
        protected getTextTag() {
            return this.get("txt");
        }

        public checked() {
            this.getIcon().addClass("checked");
            this.addClass("_checked");
            this.addToData("s", true);
        }

        public unchecked() {
            this.getIcon().removeClass("checked");
            this.removeClass("_checked");
            this.addToData("s", false);
        }
    }
}
